import type * as React from 'react'
import { Button as BaseButton } from '@/components/ui/button'
import { cn } from '@/lib/utils'

/** O Button padrão do SSMA é w-full; aqui os botões de ação ficam com largura automática. */
export const Button = ({
	className,
	...props
}: React.ComponentProps<typeof BaseButton>) => (
	<BaseButton className={cn('w-auto', className)} {...props} />
)
